import { Typography } from '@mui/material';
import { GridRenderCellParams, GridTreeNodeWithRender } from '@mui/x-data-grid';

function CaptionCell({ formattedValue }: GridRenderCellParams<GridTreeNodeWithRender, string>) {
  return (
    <Typography noWrap variant='caption' title={formattedValue}>
      {formattedValue}
    </Typography>
  );
}

export default CaptionCell;
